import "../styles/default.scss";

import classNames from "classnames";
import React from "react";
import { compose } from "redux";

import withTranslations from "../../../../../../hocs/withTranslations";
import FormatCurrency from "../../Homepage/components/FormatCurrency";
import RadioDot from "../../Homepage/components/RadioDot";
import getCurrencyOfferByPeriod from "../utils/getCurrencyOfferByPeriod";
import Period from "./Period";
import { getPaymentMethodPricing } from "../utils/useOnPaymentButtonClick";

const PlanBoxCollapsed = ({
  plan,
  isSelectedPlan,
  isHighlightedPlan,
  isRecommendedPlan,
  onSelect,
  locale,
  translate,
  period,
  showBorder,
  selectedPaymentMethod
}) => {
  const currencyOffer = getCurrencyOfferByPeriod({
    currency_offers: plan.currency_offers,
    period: period
  });

  if (!currencyOffer) {
    return null;
  }

  const paymentMethodPricing = getPaymentMethodPricing({
    currentCurrencyOfferByPeriod: currencyOffer,
    selectedPaymentMethod: selectedPaymentMethod
  });

  const isGuaranteedUserOffer = currencyOffer?.is_guaranteed_user_offer;
  const originalCurrencyOffer = isGuaranteedUserOffer
    ? currencyOffer.original_currency_offer
    : undefined;
  const bonus = plan?.bonus?.[0];

  return (
    <button
      onClick={onSelect}
      className={classNames("p-3 rounded b-none", {
        "outline-black focus-visible": isSelectedPlan,
        "bg-yellow": isHighlightedPlan,
        "bg-white": !isHighlightedPlan,
        border: showBorder
      })}
    >
      <div className={"flex gap-3 align-center"}>
        <RadioDot isSelected={isSelectedPlan} />
        <strong className={"text-lg font-semibold text-black"}>
          {plan.name}
        </strong>
        {currencyOffer ? (
          <div className="ml-auto gap-3 flex">
            <div className={"flex gap-1.5 ml-auto align-baseline"}>
              {paymentMethodPricing?.order_monthly_amount !==
              paymentMethodPricing?.monthly_amount ? (
                <strong className={"font-bold text-xl text-red-1 line-through"}>
                  <FormatCurrency
                    value={paymentMethodPricing.monthly_amount}
                    locale={locale}
                  />
                </strong>
              ) : null}
              <strong className={"font-bold text-xl text-black"}>
                <FormatCurrency
                  value={paymentMethodPricing?.order_monthly_amount ?? 0}
                  locale={locale}
                />
              </strong>
              <span className={"text-xs text-black opacity-65"}>
                <Period periods={1} />
              </span>
            </div>
          </div>
        ) : null}
      </div>
      {isSelectedPlan ? (
        <div className={"flex flex-col gap-2 text-left"}>
          <div className={"flex gap-3 flex-row justify-between align-start"}>
            {isGuaranteedUserOffer || isRecommendedPlan ? (
              <div
                className={
                  "shrink-0 bg-black-4 rounded text-xs.1 text-black font-semibold py-1.5 px-2 max-w-content uppercase leading-6 mt-2.5"
                }
              >
                {isGuaranteedUserOffer
                  ? translate("plans_box_guaranteed-user-offer")
                  : translate("plans_box_recommended")}
              </div>
            ) : (
              <div />
            )}
            {isGuaranteedUserOffer ? (
              <div
                className={
                  "text-xs.1 text-black opacity-50 flex text-right mt-2.5"
                }
              >
                <span>
                  {translate("plans_box_guaranteed-user-offer-description", {
                    originalPrice: FormatCurrency({
                      value: originalCurrencyOffer.offer_amount,
                      locale
                    }),
                    discount: FormatCurrency({
                      value:
                        originalCurrencyOffer.offer_amount -
                        currencyOffer.offer_amount,
                      locale
                    })
                  })}
                </span>
              </div>
            ) : null}
            {currencyOffer?.omnibus_price ? (
              <div className={"mt-3.5"}>
                <span className={"text-xs.1 text-black opacity-50 flex"}>
                  {translate("plans_box_omnibus-price", {
                    value: FormatCurrency({
                      value: currencyOffer.omnibus_price,
                      locale
                    })
                  })}
                </span>
              </div>
            ) : null}
          </div>
          <hr
            className={classNames("hr-horizontal-1 m-0", {
              "hr-horizontal_yellow-1": isHighlightedPlan
            })}
          />
          <p className={"text-black opacity-70 text-xs mb-0"}>
            {plan.description}
          </p>
          {bonus?.items?.length > 0 ? (
            <div className={"text-xs"}>
              <strong className={"font-semibold text-black uppercase"}>
                {translate("plans_box_bonus")}
              </strong>
              <span className={"font-semibold text-black opacity-65"}>
                {bonus.items.map(({ title }) => title).join(" + ")}
              </span>
            </div>
          ) : null}
        </div>
      ) : null}
    </button>
  );
};

export default compose(withTranslations)(PlanBoxCollapsed);
